import { Component } from '@angular/core';

@Component({
    selector: 'jhi-footer',
    templateUrl: './footer.component.html'
})
export class FooterComponent {}



// WEBPACK FOOTER //
// ./src/main/webapp/app/layouts/footer/footer.component.ts